import React from 'react';

const team = [
  {
    name: "Tank Lankenau",
    role: "Fundador de Nubbi",
    image: "/team/tank.jpeg",
    bio: "Tank es el fundador y creador de Nubbi, creativo de nacimiento, ideó Nubbi una tarde con sus hijos y de ahí en delante nunca paró. Invitó a Javier Leuchter como cofundador y juntos empezaron este universo en Abril del 2025",
    contacto: "tank@nubbi.co",
  },
  {
    name: "Javier Leuchter",
    role: "Co-Fundador de Nubbi y COO",
    image: "/team/javier.jpg",
    bio: "Javier se unió al equipo de Nubbi en Abril del 2025 luego de una invitación de Tank y juntos han logrado llevar Nubbi a lo que es hoy una gran promesa para el futuro.",
    contacto: "javi@nubbi.co",
  },
  {
    name: "Emilio Saenz",
    role: "Coordinador Legal Nubbi",
    image: "/team/emilio.jpg",
    bio: "Abogado del prestigioso despacho Canales de San Pedro Garza García y jefe Legal de todos los asuntos de Nubbi.",
  },
  {
    name: "Sisu Endeavor",
    role: "Arquitectura y Escalabilidad Nubbi",
    image: "/team/sisu.jpg",
    bio: "Empresa de arquitectura y escalabilidad responsables de llevar a Nubbi a otro nivel",
  },
  {
    name: "JN Sistemas",
    role: "Softwares Nubbi",
    image: "/team/jn.jpg",
    bio: "Bio pendiente",
  },
];

export default function OurTeam() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-700 to-blue-800 text-white px-6 py-12">
      <h1 className="text-4xl font-extrabold text-center mb-12">🌟 Our Core Team</h1>
      <div className="grid gap-12 md:grid-cols-2 max-w-6xl mx-auto">
        {team.map((member, index) => (
          <div key={index} className="flex flex-col md:flex-row items-center bg-white bg-opacity-10 rounded-xl p-6 shadow-xl">
            <img src={member.image} alt={member.name} className="w-40 h-40 rounded-full object-cover border-4 border-white mb-4 md:mb-0 md:mr-6" />
            <div>
              <h2 className="text-2xl font-bold">{member.name}</h2>
              <p className="text-yellow-300 font-semibold mb-2">{member.role}</p>
              <p className="text-white">{member.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}